import { DayjsSchema } from '@/utils';
import { z } from 'zod';

/// ////////////////////////////////////////
/// Form Schema
/// ////////////////////////////////////////

export const BulkCopyFormSchema = z.object({
  fiscalYear: DayjsSchema(),
});
